/* global axios */

import ApiClient from '../ApiClient';

class ActibidAPI extends ApiClient {
  constructor() {
    super('integrations/actibid', { accountScoped: true });
  }

  testConnection() {
    return axios.post(`${this.url}/test_connection`);
  }

  search(q) {
    return axios.post(`${this.url}/search`, { q });
  }

  getProperty(codigo, matricula) {
    return axios.post(`${this.url}/get`, { codigo, matricula });
  }

  lookup(q) {
    return axios.post(`${this.url}/lookup`, { q });
  }
}

export default new ActibidAPI();
